import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const STORAGE_KEY = 'tween.cookie-consent';

type ConsentValue = 'accepted' | 'essential';

function readConsent(): ConsentValue | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'accepted' || value === 'essential') return value;
  } catch {
    // ignore storage errors
  }
  return null;
}

function writeConsent(value: ConsentValue) {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // ignore storage errors
  }
}

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(readConsent() === null);
  }, []);

  const choose = (value: ConsentValue) => {
    writeConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-labelledby="cookie-banner-title" aria-live="polite">
      <div className="cookie-banner-inner">
        <div className="cookie-banner-copy">
          <p id="cookie-banner-title" className="cookie-banner-title">
            Cookies
          </p>
          <p className="cookie-banner-text">
            We use essential cookies to keep you signed in, plus optional cookies to understand usage
            and improve tween.studio. See our{' '}
            <Link to="/privacy" className="cookie-banner-link">
              Privacy Policy
            </Link>{' '}
            for details.
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button type="button" className="cookie-banner-btn cookie-banner-btn-secondary" onClick={() => choose('essential')}>
            Essential only
          </button>
          <button type="button" className="cookie-banner-btn cookie-banner-btn-primary" onClick={() => choose('accepted')}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
